var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized-message"},[_vm._m(0),_c('div',{staticClass:"text text-center"},[_vm._v(" "+_vm._s(_vm.$t('errors.unauthorized'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-icon"},[_c('img',{attrs:{"src":require("@/assets/icon-globe.svg"),"alt":"MariaDB"}})])
}]
render._withStripped = true
export { render, staticRenderFns }